import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import {
    TotalizerWorkAccidentChangeDto,
    WorkAccidentFilterInput,
} from "../../core/interfaces/work-accident-filter-input";
import { Subject, throwError } from 'rxjs';
import { catchError, finalize, takeUntil } from "rxjs/operators";
import { SStatsCardWorkAccidentService } from './s-stats-card-work-accident.service';
import { AccidentType } from '../../core/enums/accident-type';
@Component({
    selector: "s-stats-card-work-accident",
    templateUrl: "./s-stats-card-work-accident.component.html",
    styleUrls: ["./s-stats-card-work-accident.component.scss"]
})
export class SStatsCardWorkAccidentComponent implements AfterViewInit, OnDestroy {

    @Input() domain: string;
    @Input() service: string;
    @Input() accidentType: AccidentType;
    @Input() employeeSearch: string;
    @Output() totalizerChangeEvent = new EventEmitter<TotalizerWorkAccidentChangeDto >();

    totalizerCountLoading = true;
    totalizerCountError = false;

    private readonly _filter: WorkAccidentFilterInput = {};
    private readonly _ngUnsubscribe = new Subject();
    private _totalizerAccidentCount: string | number;
    private _totalizerTypicalCount: string | number;
    private _totalizerRouteCount: string | number;
    private _totalizerDiseaseCount: string | number;

    constructor(
        private readonly _translateService: TranslateService,
        private readonly route: ActivatedRoute,
        private readonly _sStatsCardWorkAccidentServiceservice: SStatsCardWorkAccidentService
    ) {}
    ngOnDestroy(): void {
        this._ngUnsubscribe.next();
        this._ngUnsubscribe.complete();
    }
    @Input()
    public set ticket(ticket) {
        this._filter.ticket = ticket;
        if (ticket && this.domain && this.service) {
            this.updateCounters();
        }
    }
    ngAfterViewInit() {
        if (!this._filter?.ticket) {
            this.updateCounters();
        }
    }
    private genericGet(value: string | number): string {
        if (typeof value === 'string') {
            return value;
        }
        return value && value >= 1 ? value.toString() : '0';
    }

    private setFields() {
        this._filter.domain = this.domain;
        this._filter.service = this.getService();
        this._filter.accidentType = this.accidentType;
        this._filter.employeeSearch = this.employeeSearch;
    }

    public updateCounters() {
        this.totalizerCountLoading = true;
        const messageError = this._translateService.instant('hcm.analytics_sst.error_fetching_count');
        this.setFields();
        this._sStatsCardWorkAccidentServiceservice.totalizerAccidentsCardsCount(this._filter)
            .pipe(
                takeUntil(this._ngUnsubscribe),
                finalize(() => {
                    const totalizerChangeDto: TotalizerWorkAccidentChangeDto = {
                        totalizerAccidentCount: this.totalizerAccidentCount,
                        totalizerTypicalCount: this.totalizerTypicalCount,
                        totalizerRouteCount: this.totalizerRouteCount,
                        totalizerDiseaseCount: this.totalizerDiseaseCount,
                    };
                    this.totalizerChangeEvent.next(totalizerChangeDto);
                })
            )
            .pipe(catchError(error => {
                this.totalizerAccidentCount = messageError;
                this.totalizerTypicalCount = messageError;
                this.totalizerRouteCount = messageError;
                this.totalizerDiseaseCount = messageError;
                this.totalizerCountLoading = false;
                this.totalizerCountError = true;
                return throwError(error);
            }))
            .subscribe((data: any) => {
                this.totalizerAccidentCount = data.result.workAccidentTotalCount;
                this.totalizerTypicalCount = data.result.typicalCount;
                this.totalizerRouteCount = data.result.routeCount;
                this.totalizerDiseaseCount = data.result.diseaseCount;

                this.totalizerCountError = false;
                this.totalizerCountLoading = false;
            });
    }

    get totalizerAccidentCount() {
        return this.genericGet(this._totalizerAccidentCount);
    }

    set totalizerAccidentCount(value: string | number) {
        this._totalizerAccidentCount = value;
    }

    get totalizerTypicalCount() {
        return this.genericGet(this._totalizerTypicalCount);
    }

    set totalizerTypicalCount(value: string | number) {
        this._totalizerTypicalCount = value;
    }

    get totalizerRouteCount() {
        return this.genericGet(this._totalizerRouteCount);
    }

    set totalizerRouteCount(value: string | number) {
        this._totalizerRouteCount = value;
    }

    get totalizerDiseaseCount() {
        return this.genericGet(this._totalizerDiseaseCount);
    }

    set totalizerDiseaseCount(value: string | number) {
        this._totalizerDiseaseCount = value;
    }

    /**
     * Esse funÃ§Ã£o foi criada pra chavear o contexto do filtro avanÃ§ado.
     * Quando vier do analytics-frontend, deve passar o serviÃ§o analytics, quando abrir direto na tela
     * do analytics-sst, deve passar o serviÃ§o do analytics_sst
     * o parametro "ticket" sÃ³ vai vir na rota, atrÃ¡ves do analytics-frontend
     * @private
     */
    private getService() {
        let service = this.service;
        if (this.route?.snapshot?.queryParams["ticket"]) {
            service = "analytics";
        }
        return service;
    }
}
